import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {FoulsDomainModel} from "./fouls.domain-model";

export class FoulsViewModel extends BaseViewModel {
  domainModel: FoulsDomainModel;

  get total(): Number {
    return this.domainModel.total;
  }

  get current(): Number {
    return this.domainModel.current;
  }

  get hasBonus(): Boolean {
    return this.domainModel.hasBonus;
  }
}
